// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs-bar {\n  display: contents;\n}\n.tabs-bar .briq-panel {\n  display: flex;\n  justify-content: space-between;\n  padding: 24px 32px;\n}\n.tab {\n  display: none;\n}\n.tab:target {\n  display: default;\n}\n.buttons > .briq-button {\n  margin-left: 8px;\n}\n.buttons-bottom > .briq-button:first-child {\n  margin-right: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
